import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Marker, Tooltip } from "react-leaflet";
import { roleIcon } from "./roleMarkers";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const icon = roleIcon("partner", { size: 32 });

// Restaurants partenaires localisés sur la carte d'accueil ; un tap ouvre leur menu
export const MapRestaurants = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);

  useEffect(() => {
    axios.get(`${API}/food/restaurants`).then((r) => setList((r.data.restaurants || []).filter((x) => x.latitude != null && x.longitude != null))).catch(() => {});
  }, []);

  return list.map((r) => (
    <Marker key={r.id} position={[r.latitude, r.longitude]} icon={icon} zIndexOffset={900}
      eventHandlers={{ click: () => navigate(`/food?restaurant=${r.id}`) }}>
      <Tooltip direction="top" offset={[0, -14]}>
        <span data-testid={`home-restaurant-pin-${r.id}`}>{r.name}{r.is_open ? "" : " · Fermé"}</span>
      </Tooltip>
    </Marker>
  ));
};
